<script setup lang="ts">
import SettingsIcon from '@/dashboard/vue/components/icons/SettingsIcon.vue';
import InfoIcon from '@/dashboard/vue/components/icons/InfoIcon.vue';
import CirclePlusIcon from '@/dashboard/vue/components/icons/CirclePlusIcon.vue';
import WorkspaceInfoSection from '@/dashboard/vue/components/workspace/WorkspaceInfoSection.vue';
import UserUsageInfoItem from '@/dashboard/vue/components/workspace/UserUsageInfoItem/UserUsageInfoItem.vue';
import Divider from '@/dashboard/vue/components/common/Divider.vue';
import WorkspaceUsageMeter from '@/dashboard/vue/components/workspace/WorkspaceUsageMeter.vue';
import { useWorkspaceTeamSection } from '@/dashboard/vue/components/workspace/WorkspaceTeamSection/useWorkspaceTeamSection';
import Tooltip from '@/dashboard/vue/components/common/Tooltip.vue';

const { canAddUsers, currentWorkspaceUser, workspace, addUser } = useWorkspaceTeamSection();
</script>

<template>
  <section>
    <WorkspaceInfoSection>
      <div class="h5 mb-m text-center text-black dark:text-white laptop:mb-[28px] laptop:text-left">{{ workspace?.name }} Usage</div>

      <WorkspaceUsageMeter v-if="workspace && currentWorkspaceUser" :workspace="workspace" :workspace-user="currentWorkspaceUser" />

      <div v-if="workspace" class="text-caption-s flex h-[72px] justify-between rounded-16 bg-gray-150 pl-l dark:bg-gray-900">
        <div class="flex items-center gap-s text-black dark:text-gray-500">
          <span>{{ workspace?.users.length }} users(s) in {{ workspace?.name }}</span>
          <span v-if="canAddUsers" class="hidden laptop:flex">/</span>
          <span v-if="canAddUsers" class="hidden items-center gap-x-xs laptop:flex">
            <span>You have {{ workspace.subscription?.quantity ?? 0 }} seat</span>
            <Tooltip>
              <template #title>
                <InfoIcon class="cursor-pointer stroke-gray-400 dark:stroke-gray-650" />
              </template>
              <template #body>
                <span class="w-[264px]">Subscribed seats: Owner, Admins, Creators. Viewers and Clients are free.</span>
              </template>
            </Tooltip>
          </span>
          <span v-if="false">/</span>
          <span v-if="false" class="flex items-center">
            <SettingsIcon class="mr-xs h-s w-s stroke-black dark:stroke-gray-500" />
            <span>Settings</span>
          </span>
        </div>

        <div class="mr-[14px] hidden w-[224px] items-center laptop:flex">
          <button v-if="canAddUsers" class="tppr-button white dark:primary sl group flex w-full !pb-zero" @click="() => addUser()">
            <CirclePlusIcon class="ml-[-3px] mr-xs min-w-[17px] stroke-black dark:stroke-gray-500 dark:group-hover:stroke-white" />
            <span class="text-caption-s text-black dark:text-gray-500 dark:group-hover:text-white">Invite a teammate</span>
          </button>
        </div>
      </div>

      <div v-if="workspace" class="mt-xl flex flex-col">
        <div v-for="(user, index) in workspace?.users" :key="user.id" class="flex flex-col">
          <UserUsageInfoItem :id="user.id" :name="user.name" :email="user.email" :role="user.role" :temp="user.temp" :image="user.image" />
          <Divider v-if="(index as number) < workspace.users.length - 1" class="divider-gray-400 my-[12px]" />
        </div>
      </div>
    </WorkspaceInfoSection>
  </section>
</template>
